import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import { usePlacesWidget } from "react-google-autocomplete";

const ModalGoogleAddress = ({
	children,
	type,
	label,
	disabled,
	required,
	hidden,
	onSubmit,
	messageValue,
	toggleFocusOn,
	setAddressStripeInfos,
	setCityStripeInfos,
	setPostalCodeStripeInfos,
	setChatBotMessageValue,
	setUserInfos
}) => {

	const [focus, setFocus] = useState(false);

	useEffect(() => {
		ref.current.focus();
	}, [toggleFocusOn]);

	useEffect(() => {
		window.scrollTo(0,document.body.scrollHeight);
	}, [focus]);

	const { ref } = usePlacesWidget({
		apiKey: "AIzaSyD_B5jjfUQkCQRQPPZqpvSDgJQkxj1QICE",
		onPlaceSelected: (place) => {
			if (!place.name) {
				const city = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "locality") {
							return obj.long_name;
						}
					});
				});

				const streetNumber = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "street_number") {
							return obj.long_name;
						}
					});
				});

				const postalCode = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "postal_code") {
							return obj.long_name;
						}
					});
				});

				const route = place.address_components.find((obj) => {
					return obj.types.find((i) => {
						if (i === "route") {
							return obj.long_name;
						}
					});
				});
				const address = streetNumber.long_name + " " + route.long_name;
				setAddressStripeInfos(address, "route");
				setPostalCodeStripeInfos(postalCode.long_name, "cp");
				setCityStripeInfos(city.long_name, "city");

				setUserInfos(address, "route");
				setUserInfos(postalCode.long_name, "cp");
				setUserInfos(city.long_name, "city");

				setChatBotMessageValue(place.formatted_address);
			} else {
				setAddressStripeInfos(place.name, "route");
				setUserInfos(place.name, "route");
			}

		},
		options: {
			types: ["address"],
			componentRestrictions: { country: "fr" },
		},
	});
	return (
		<form id="response" onSubmit={onSubmit} autoComplete="off">
			<input
				name="message"
				className="response"
				type={type}
				placeholder={label}
				onChange={(e) => {
					setChatBotMessageValue(e.target.value);
					if (!window["ReactNativeWebView"]) {
						setFocus(!focus);
					}
				}}
				onFocus={() => {
					if (window["ReactNativeWebView"]) {
						window.ReactNativeWebView.postMessage("googleAddress");
						// document.getElementById("containerResponse").style.height = "30vh";
						// document.getElementById("containerResponse").style.zIndex = "100";
					} else {
						if (window.innerWidth < 1026 && !window["ReactNativeWebView"]) {
							document.getElementById("containerResponse").style.height = "30vh";
						} else {
							document.getElementById("containerResponse").style.height = "30vh";
						}
					}
					window.scrollTo(0,document.body.scrollHeight);
				}}
				onBlur={() => {
					if (window.innerWidth < 1026) {
						document.getElementById("containerResponse").style.height = "";
					} else {
						document.getElementById("containerResponse").style.height = "";
					}
				}}
				value={messageValue}
				required={required}
				disabled={disabled}
				hidden={hidden}
				ref={ref}
				autoComplete="new-password"
			/>
			<input autoComplete="on" style={{ display: "none" }} id="fake-hidden-input-to-stop-google-address-lookup"/>
			{children}
		</form>
	);
};

ModalGoogleAddress.propTypes = {
	type: PropTypes.string,
	onSubmit: PropTypes.func,
	label: PropTypes.string,
	src: PropTypes.string,
	onChange: PropTypes.func,
	email: PropTypes.string,
	setUserInfos: PropTypes.func,
	valueToActive: PropTypes.string,
	value: PropTypes.string,
	fade: PropTypes.string,
	fadeOut: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	ref: PropTypes.string,
	toggleFocusOn: PropTypes.bool,
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	children: PropTypes.node,
	messageValue: PropTypes.string,
	setChatBotMessageValue: PropTypes.func,
	setAddressStripeInfos: PropTypes.func,
	setCityStripeInfos: PropTypes.func,
	setPostalCodeStripeInfos: PropTypes.func,
};

export default ModalGoogleAddress;